module["exports"] = [
  "Qasımova",
  "Əfəndiyeva",
  "Soltanova",
  "Abdullayeva",
  "Rəşidova",
  "Ələkbərova",
  "Əliyeva",
  "Tahirova",
  "Seyidova",
  "Vəsiyeva"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/name/female_last_name.js
// module id = 189
// module chunks = 0